export default {
      id: "x-close-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#x-close-usage",
      toString: function () {
        return this.url;
      }
    }